<template>
  <gjw-dialog
      :show-dialog="showPublicDialog"
      title="创建交付模型"
      :config="{ width:'472px', class:'no-padding-bottom' }"
      @confirm="comfirmClick"
      @close="closeDialog">
    <div class="dialog-content">
      <div class="dialog-tip">
        <i class="el-icon-warning dialog-tip-icon"/>
        <div class="dialog-tip-text">
          <div class="">正在创建交付模型</div>
          <div style="font-size: 12px;color: #919FA9;">说明：创建的交付模型<span style="color:#495F70;">不再随着文件版本的变动而更新</span></div>
        </div>
      </div>
      <el-form ref="publishForm" :model="publishInfo" :rules="rules" label-position="left" label-width="56px" @submit.native.prevent>
        <el-form-item label="名称：" prop="name">
          <el-input :maxlength="30" placeholder="请输入30个字内模型名称" v-model="publishInfo.name" />
        </el-form-item>
        <el-form-item label="设置：">
          <el-checkbox v-model="publishInfo.isWithViewPoints">同时发布视点</el-checkbox>
          <el-checkbox v-model="publishInfo.isGenerateOfflinePackage">同时生成离线包</el-checkbox>
        </el-form-item>
      </el-form>
    </div>
  </gjw-dialog>
</template>

<script>
import { federationErrorCodeMap } from '@/views/file/errorCodeMap'
import { RegSymbol } from '@/core/RegExp'

export default {
  name: 'FederationPublishDialog',
  data() {
    const validName = (rule, value, callback) => {
      if (!value && value !== 0) {
        callback(new Error(`请输入30个字内模型名称`))
      } else if (RegSymbol.test(value)) {
        callback(new Error(`不能包含特殊字符：\\ /:*<>|?'"#%`))
      } else {
        callback()
      }
    }
    return {
      spaceId: this.$route.params.spaceId,
      showPublicDialog: false,
      publishInfo: {
        name: '',
        // 是否同时发布视点
        isWithViewPoints: true,
        // 是否同时生成离线包
        isGenerateOfflinePackage: false,
      },
      rules: {
        name: [{ validator: validName, trigger: 'blur' }]
      }
    }
  },
  methods: {
    async openDialog(row) {
      this.publishInfo = { ...this.publishInfo, ...row }
      this.showPublicDialog = true
    },
    closeDialog() {
      this.$refs.publishForm && this.$refs.publishForm.resetFields()
      this.showPublicDialog = false
      this.publishInfo = { name: '', isWithViewPoints: true, isGenerateOfflinePackage: false, }
    },
    comfirmClick() {
      if (!this.$checkForm('publishForm')) { return }
      const { name, isWithViewPoints, isGenerateOfflinePackage } = this.publishInfo
      const params = {
        integratedModelName: name,
        isWithViewPoints,
        isGenerateOfflinePackage,
      }
      this.$api.file.publishFederationPlan(this.spaceId, this.publishInfo.id, params).then((data) => {
        this.closeDialog()
        if (data.isSuccess) {
          this.$confirm(`创建成功！`, {
            cancelButtonText: '暂不前往',
            confirmButtonText: '前往查看',
            showClose: false,
            type: 'success',
          }).then(() => {
            // 跳转到整合模型列表页
            this.$router.push({ name: 'IntegratedModelList', params: { spaceId: this.spaceId }})
          }).catch(() => {})
          this.$tracks({
            event: 'publishFederatedPlan',
            params: {
              g_c_space_id: this.spaceId,
              g_c_federated_plan_id: this.publishInfo.id,
            }
          })
          // 如果勾选了同时生成离线包，则还要埋点导出离线包
          if (isGenerateOfflinePackage) {
            this.$tracks({
              event: 'exportOfflinePackage',
              params: { g_c_space_id: this.spaceId, g_c_file_id: this.publishInfo.id, g_c_file_type: 'FEDERATED_PLAN' }
            })
          }
        } else {
          let messageText = ''
          const length = data.fileItems?.length
          if (!length) {
            messageText = `该方案下无可查看模型，无法创建交付模型。`
          } else {
            const failFiles = data.fileItems.filter((item) => item.checkStatus !== 'NORMAL')
            const errFile = failFiles[0]
            const errFileName = errFile.suffix ? `${errFile.fileName}.${errFile.suffix}` : errFile.fileName
            messageText = `${errFileName}等${failFiles.length}个文件异常，无法创建交付模型。`
          }
          this.$confirm(messageText, {
            confirmButtonText: '查看详情',
            cancelButtonText: '取消',
            showClose: false,
            type: 'warning',
          }).then(() => {
            this.$emit('publish-error-detail', this.publishInfo)
          }).catch(() => {})
        }
      }).catch((err) => {
        this.$matchError(err.code, federationErrorCodeMap, '创建失败，请联系官方客服')
      })
    },
  },
}
</script>

<style lang="less" scoped>
.dialog-content{

}
.dialog-tip{
  display: flex;
  flex-direction: row;
  padding: 12px 20px;
  border-radius: 4px;
  background: #F7F9FA;
  margin-bottom: 16px;
}
.dialog-tip-icon{
  font-size: 24px;
  color: @theme-color;
  margin-right: 16px;
}
.dialog-tip-text{
  line-height: 24px;
}
.dialog-footer{
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-top: 16px;
  padding: 0 10px;
  /deep/.el-checkbox__label{
    font-weight: normal;
  }
  /deep/.el-checkbox__input.is-checked+.el-checkbox__label{
    color: #495F70;
    font-weight: normal;
  }
}
</style>
